import request from "@/api/axios";
import { DEV_SYSTEM, AUTH_SERVICE } from "@/api/config/servicePort";

// 获取用户信息
export const getCurrentAdminUserInfo = (): Promise<IResponse> => {
  return request.get({ url: AUTH_SERVICE + "/user/admin/current/info" });
};

// 设计师修改自身信息数据
export const designerChangeOwnDataApi = (data: any): Promise<IResponse> => {
  return request.post({ url: DEV_SYSTEM + "/designerInfo/designerInfo", data });
};

//设计师修改自身接单状态
export const postDesignerWorkStatusApi = (params: any): Promise<IResponse> => {
  return request.put({ url: DEV_SYSTEM + `/designerInfo/update/qywx/workstatus/${params.dataID}`, params });
};

// 获取邀请码链接
export const getInvitationCodeApi = (): Promise<IResponse> => {
  return request.get({ url: AUTH_SERVICE + `/user/code` });
};
